<template>
  <div>
  	<AmapShow :class="amap-show" v-on:AmapShow='closeMap'>
    </AmapShow>
  </div>
</template>
<script>
import { expire } from '@/utils/auth'
import AmapShow from '@/containers/DataTablePage/amapShow'

export default {
  name: 'map',
  components: {
    AmapShow
  },
  data () {
    return {
      test: true
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  beforeDestroy () {
    console.log('11')
  },
  methods: {
    getEchartHeight () {
      this.tabHeight = this.$refs.tabList.$el.clientHeight - 60
      this.tabWidth = this.$refs.tabList.$el.clientWidth - 40
    }
  }
}
</script>
<style scoped lang="sass">
</style>


// WEBPACK FOOTER //
// counterMap.vue?5313a16e